<template>
  <v-card class="mx-auto">    
    <v-container>
      <v-list subheader>
        <v-list-item-title class="title">Scores</v-list-item-title>
        <v-list-item v-for="item in players" :key="item.title">
          <v-list-item-avatar>
            <v-img :src="item.image"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="item.player"></v-list-item-title>
          </v-list-item-content>

          <v-list-item-content>
            <v-list-item-title v-text="item.score"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </v-card>
</template>

<script>
import refs from "./firebase/refs";

export default {
  name: "Players",
  props: {
    gameId: String,
  },
  components: {},
  created() {
    refs.players(this.gameId).on("value", (snapshot) => {
      var newPlayers = [];
      snapshot.forEach((player) => {
        newPlayers.push({
          player: player.val().player,
          image: player.val().image,
          score: player.val().score,
        });
        this.players = newPlayers;
      });
    });
  },
  data() {
    return {
      players: [],
    };
  },
};
</script>
